import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Navigate, useNavigate } from "react-router-dom";
import "./LeftSideMenu.scss";
import Auth from "../../utils/auth";
import { t } from "i18next";
import Utils from "../../utils";

const LeftSideMenuData = {
  Role: "ADMIN",
  Desc: "",
  // menu: [
  //   {
  //     title: "Home",
  //     path: "/dashboard",
  //     component: "HomeComponent",
  //     ico: "",
  //     submenu: [
  //       {
  //         title: "Assistants",
  //         path: "/dashboard/assistants",
  //         component: "AssistantsComponent",
  //         ico: "",
  //       },
  //       {
  //         title: "Builder",
  //         path: "/dashboard/mainDashboard",
  //         component: "Builder",
  //         ico: "",
  //       }
  //     ],
  //   },
  // ],
};

const DashBoardSideBar = ({ isMenuOpen, toggleMenu }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [user, setUser] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [menuData, setMenuData] = useState({ menu: [], role: "" });
  const token = Utils.getLocalStorageItem("_t");
  const fetchConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/config`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Access-Token": token,
          },
        }
      );

      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }

      const configData = await response.json();

      await localStorage.setItem("userAccess", configData?.data?.avl?.headless);
    } catch (error) {
      console.error("Error fetching configuration:", error);
    }
  };
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    if (userData) {
      setUser(userData);
    }

    const fetchMenuData = async () => {
      const userId = userData?.emailID;
      const authToken = Auth.getToken();
      const role = userData?.role;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}genai/listmenus`,
          {
            method: "POST",
            // signal: signal,
            headers: {
              "x-access-token": authToken,
            },
            body: JSON.stringify({ userId }),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch menu data");
        }

        let data = await response.json();
        Utils.setLocalStorageItem("accessMenus", data);
        setMenuData({ menu: data.menus, role: role }, (data) => {});
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    fetchMenuData();

    const initialSubItemData = LeftSideMenuData?.menu?.find(
      (subItem) => subItem?.submenu
    );
    const initialSubItem = initialSubItemData?.submenu?.find(
      (subItem) => subItem?.title === "Assistants"
    );
    if (initialSubItem) {
      setSelectedSubItem(initialSubItem);
      // navigate(initialSubItem.path);
    }
    fetchConfig();
  }, []);
  const handleSignOut = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("_t");
    navigate("/");
  };

  const handleItemClick = (subItem) => {
    if (subItem?.path) {
      setSelectedSubItem(subItem);
      navigate(subItem.path);
    } else if (subItem?.title == "Feedback") {
      window.$("#pmModal").modal("show").css("z-index", 99999);
    }
  };

  const closeDataModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section
      className={`dashboard-Sidebarsection ${isMenuOpen ? "opened" : "closed"}`}
    >
      <div className="menu-close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="cursor-pointer"
          onClick={toggleMenu}
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="rgba(0,0,0,1)"
        >
          <path d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"></path>
        </svg>
      </div>
      <div className="niit-lgo">
        <svg
          width="212"
          height="48"
          viewBox="0 0 212 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M77.66 33.124H84.629V42.002H81.662L81.386 40.484C80.8647 41.1126 80.19 41.565 79.362 41.841C78.5493 42.1016 77.6907 42.232 76.786 42.232C75.1607 42.232 73.75 41.91 72.554 41.266C71.3733 40.622 70.4533 39.702 69.794 38.506C69.15 37.2946 68.828 35.8456 68.828 34.159C68.828 32.4416 69.196 30.9313 69.932 29.628C70.6833 28.3093 71.7413 27.282 73.106 26.546C74.4707 25.81 76.073 25.442 77.913 25.442C79.4617 25.442 80.765 25.718 81.823 26.27C82.8963 26.8066 83.7933 27.627 84.514 28.731L81.639 30.824C81.2557 30.134 80.7267 29.6356 80.052 29.329C79.3773 29.007 78.6643 28.846 77.913 28.846C76.8397 28.846 75.9197 29.0683 75.153 29.513C74.3863 29.9423 73.7883 30.5556 73.359 31.353C72.945 32.135 72.738 33.0473 72.738 34.09C72.738 35.608 73.1367 36.781 73.934 37.609C74.7313 38.437 75.8277 38.851 77.223 38.851C77.775 38.851 78.327 38.759 78.879 38.575C79.431 38.3756 79.8987 38.0766 80.282 37.678C80.6807 37.2793 80.9183 36.781 80.995 36.183H77.66V33.124ZM92.7843 42.232C91.481 42.232 90.354 41.9943 89.4033 41.519C88.4526 41.0283 87.7166 40.346 87.1953 39.472C86.674 38.5826 86.4133 37.5323 86.4133 36.321C86.4133 35.0943 86.674 34.0133 87.1953 33.078C87.732 32.1426 88.445 31.4143 89.3343 30.893C90.239 30.3716 91.2586 30.111 92.3933 30.111C93.6813 30.111 94.7316 30.4023 95.5443 30.985C96.357 31.5676 96.9166 32.3956 97.2233 33.469C97.5453 34.527 97.6143 35.7613 97.4303 37.172H90.0013C90.0933 37.7546 90.4 38.2453 90.9213 38.644C91.4426 39.0273 92.1556 39.219 93.0603 39.219C93.4743 39.219 93.9113 39.1346 94.3713 38.966C94.8313 38.782 95.2223 38.5136 95.5443 38.161L97.4993 40.231C96.9933 40.8443 96.3646 41.335 95.6133 41.703C94.8773 42.0556 93.9343 42.232 92.7843 42.232ZM92.4623 32.664C91.849 32.664 91.3276 32.848 90.8983 33.216C90.4843 33.584 90.2083 34.0976 90.0703 34.757H94.4633C94.4786 34.0363 94.3023 33.5073 93.9343 33.17C93.5816 32.8326 93.091 32.664 92.4623 32.664ZM99.5894 42.002V30.295H103.085L102.924 32.802C103.4 31.9433 104.005 31.284 104.741 30.824C105.493 30.3486 106.328 30.111 107.248 30.111C108.644 30.111 109.686 30.5863 110.376 31.537C111.066 32.4723 111.404 33.8216 111.388 35.585L111.342 42.002H107.823L107.869 35.838C107.885 35.0406 107.762 34.435 107.501 34.021C107.256 33.5916 106.857 33.377 106.305 33.377C105.845 33.377 105.424 33.515 105.04 33.791C104.657 34.0516 104.32 34.504 104.028 35.148C103.752 35.792 103.53 36.6736 103.361 37.793C103.193 38.9123 103.101 40.3153 103.085 42.002H99.5894ZM112.01 42.002L119.095 25.672H122.246L129.054 42.002H125.235L123.925 38.667H117.186L115.829 42.002H112.01ZM118.473 35.539H122.683L120.613 30.272L118.473 35.539ZM130.141 42.002V25.672H133.89V42.002H130.141ZM148.054 42.209C146.045 42.209 144.489 41.7796 143.385 40.921C142.281 40.0623 141.652 38.7973 141.499 37.126L145.018 36.62C145.11 37.4173 145.424 38.0306 145.961 38.46C146.497 38.874 147.241 39.081 148.192 39.081C149.004 39.081 149.625 38.943 150.055 38.667C150.499 38.3756 150.722 37.9693 150.722 37.448C150.722 36.9726 150.492 36.597 150.032 36.321C149.572 36.045 148.813 35.7843 147.755 35.539C146.62 35.263 145.662 34.9333 144.88 34.55C144.098 34.1513 143.507 33.6376 143.109 33.009C142.71 32.3803 142.511 31.583 142.511 30.617C142.511 29.605 142.771 28.708 143.293 27.926C143.814 27.144 144.542 26.5383 145.478 26.109C146.413 25.6643 147.494 25.442 148.721 25.442C150.315 25.442 151.619 25.8483 152.631 26.661C153.643 27.4736 154.225 28.5853 154.379 29.996L151.09 30.548C150.967 29.9193 150.683 29.4363 150.239 29.099C149.794 28.7463 149.234 28.57 148.56 28.57C147.885 28.57 147.341 28.731 146.927 29.053C146.513 29.3596 146.306 29.7813 146.306 30.318C146.306 30.8086 146.505 31.2073 146.904 31.514C147.302 31.8053 148.031 32.0813 149.089 32.342C150.208 32.618 151.174 32.9323 151.987 33.285C152.799 33.6223 153.42 34.09 153.85 34.688C154.294 35.286 154.517 36.0986 154.517 37.126C154.517 38.1226 154.248 39.0043 153.712 39.771C153.175 40.5376 152.416 41.1356 151.435 41.565C150.469 41.9943 149.342 42.209 148.054 42.209ZM161.166 42.232C159.725 42.232 158.582 41.8333 157.739 41.036C156.896 40.2233 156.482 39.1576 156.497 37.839L156.589 33.216H154.657V30.295H156.635L156.658 27.903H160.154L160.131 30.295H163.788V33.216H160.085L160.016 37.448C160.016 38 160.162 38.4293 160.453 38.736C160.744 39.0426 161.181 39.196 161.764 39.196C162.101 39.196 162.423 39.1576 162.73 39.081C163.052 38.989 163.382 38.8203 163.719 38.575L164.731 41.266C163.949 41.91 162.761 42.232 161.166 42.232ZM169.489 42.232C168.139 42.232 167.12 41.772 166.43 40.852C165.74 39.932 165.402 38.6516 165.418 37.011L165.464 30.295H168.983L168.937 36.735C168.937 37.425 169.059 37.9693 169.305 38.368C169.55 38.7666 169.933 38.966 170.455 38.966C170.899 38.966 171.306 38.828 171.674 38.552C172.042 38.276 172.364 37.816 172.64 37.172C172.916 36.528 173.13 35.6463 173.284 34.527C173.452 33.4076 173.544 31.997 173.56 30.295H176.964V42.002H173.445L173.606 39.748C173.146 40.5453 172.563 41.1586 171.858 41.588C171.152 42.0173 170.363 42.232 169.489 42.232ZM191.163 24.982V42.002H187.621L187.736 40.277C186.892 41.5803 185.643 42.232 183.987 42.232C182.944 42.232 182.055 41.9943 181.319 41.519C180.583 41.0436 180.023 40.3843 179.64 39.541C179.256 38.6976 179.065 37.7316 179.065 36.643C179.065 35.3396 179.333 34.1973 179.87 33.216C180.406 32.2346 181.127 31.4756 182.032 30.939C182.936 30.387 183.948 30.111 185.068 30.111C185.589 30.111 186.072 30.1876 186.517 30.341C186.961 30.4943 187.345 30.709 187.667 30.985L187.644 30.295V24.982H191.163ZM185.413 33.17C184.569 33.17 183.902 33.4843 183.412 34.113C182.936 34.7416 182.699 35.5466 182.699 36.528C182.699 37.3713 182.883 38.023 183.251 38.483C183.634 38.943 184.148 39.173 184.792 39.173C185.574 39.173 186.241 38.851 186.793 38.207C187.36 37.563 187.644 36.7196 187.644 35.677C187.644 34.895 187.444 34.2816 187.046 33.837C186.647 33.3923 186.103 33.17 185.413 33.17ZM197.399 30.295V42.002H193.88V30.295H197.399ZM195.628 28.915C194.954 28.915 194.417 28.708 194.018 28.294C193.62 27.88 193.42 27.3893 193.42 26.822C193.42 26.2546 193.612 25.764 193.995 25.35C194.394 24.936 194.938 24.729 195.628 24.729C196.303 24.729 196.84 24.936 197.238 25.35C197.637 25.764 197.836 26.2546 197.836 26.822C197.836 27.3893 197.637 27.88 197.238 28.294C196.84 28.708 196.303 28.915 195.628 28.915ZM205.807 30.111C207.631 30.111 209.057 30.6323 210.085 31.675C211.127 32.7176 211.649 34.1283 211.649 35.907C211.649 37.1183 211.388 38.1993 210.867 39.15C210.345 40.1006 209.609 40.852 208.659 41.404C207.708 41.956 206.589 42.232 205.301 42.232C203.491 42.232 202.065 41.7106 201.023 40.668C199.995 39.6253 199.482 38.2223 199.482 36.459C199.482 35.2323 199.742 34.1436 200.264 33.193C200.785 32.2423 201.521 31.491 202.472 30.939C203.422 30.387 204.534 30.111 205.807 30.111ZM205.462 39.173C206.244 39.173 206.865 38.8816 207.325 38.299C207.8 37.701 208.038 36.9036 208.038 35.907C208.038 35.0483 207.831 34.3813 207.417 33.906C207.003 33.4153 206.435 33.17 205.715 33.17C204.917 33.17 204.281 33.469 203.806 34.067C203.346 34.6496 203.116 35.4393 203.116 36.436C203.116 37.2946 203.315 37.9693 203.714 38.46C204.128 38.9353 204.71 39.173 205.462 39.173Z"
            fill="#002346"
          />
          <path
            d="M68 3.00195H73.0092C73.7541 4.74753 74.4833 6.50031 75.2223 8.24785C75.2643 7.39933 75.2511 6.54818 75.238 5.699C75.1659 5.27277 74.661 5.13704 74.2885 5.14294C74.2695 4.43015 74.2918 3.7154 74.2833 3.00195H79.0125C79.0125 3.72326 79.0144 4.44458 79.0079 5.16523C78.6223 5.15081 78.0898 5.30228 78.0466 5.7554C78.0407 8.68458 78.0393 11.6138 78.0407 14.5429C78.0439 14.6964 78.0466 14.8511 78.0125 15.002H74.1436C74.0387 14.8813 73.998 14.7246 73.9357 14.581C73.2184 12.8413 72.4813 11.1095 71.781 9.36326C71.7449 10.3383 71.7561 11.3147 71.7685 12.2892C71.8597 12.7036 72.3469 12.8177 72.7134 12.8183C72.7062 13.5462 72.7305 14.2747 72.697 15.002H68V12.819C68.4492 12.9029 69.0374 12.5698 68.9541 12.0524C68.9502 9.95277 68.9561 7.85244 68.9508 5.75212C68.9102 5.3049 68.3816 5.15081 68 5.16982V3.00195Z"
            fill="#002346"
          />
          <path
            d="M79.4866 3.00195H84.6978C84.6965 3.7272 84.7043 4.45179 84.7017 5.17703C84.3017 5.16261 83.745 5.339 83.7358 5.81835C83.7312 7.91933 83.7332 10.021 83.7345 12.1226C83.7233 12.6242 84.2932 12.8308 84.7128 12.819C84.7076 13.5469 84.7247 14.2747 84.6971 15.002H79.5102C79.4722 14.2839 79.5063 13.5639 79.4925 12.8446C79.7942 12.817 80.1358 12.7744 80.3443 12.5285C80.4774 12.379 80.4551 12.1692 80.4558 11.9849C80.4532 9.99671 80.4538 8.00851 80.4591 6.02031C80.4584 5.8354 80.4715 5.62884 80.343 5.47802C80.1528 5.20458 79.7883 5.18228 79.4866 5.15212C79.486 4.4354 79.4866 3.71867 79.4866 3.00195Z"
            fill="#002346"
          />
          <path
            d="M85.1849 3.00195H90.3921C90.3915 3.72654 90.3928 4.45179 90.3915 5.17638C90.017 5.17769 89.4859 5.3049 89.4426 5.75146C89.44 7.91933 89.4315 10.0872 89.4479 12.2544C89.5128 12.6846 90.0203 12.8118 90.3908 12.8144C90.4013 13.5429 90.398 14.2728 90.3902 15.002H85.2203C85.1705 14.2806 85.2105 13.5567 85.1921 12.8341C85.5705 12.8367 86.101 12.7003 86.1423 12.2505C86.1462 10.0859 86.1495 7.9213 86.1403 5.75671C86.1082 5.29572 85.5665 5.15408 85.1836 5.15081C85.1862 4.43474 85.1842 3.71802 85.1849 3.00195Z"
            fill="#002346"
          />
          <path
            d="M90.8926 3.00195H100.786V7.91999C99.9582 7.91933 99.13 7.92064 98.3024 7.91933C98.3004 7.26425 98.3057 6.60917 98.3004 5.95474C98.2827 5.69966 98.1463 5.35474 97.8414 5.3613C97.6093 5.40982 97.5123 5.6754 97.5227 5.88851C97.526 7.91933 97.5188 9.94949 97.5182 11.9803C97.5175 12.1626 97.4985 12.3698 97.6329 12.5147C97.8368 12.7515 98.1686 12.7974 98.4631 12.819C98.4611 13.5469 98.4736 14.2747 98.4559 15.002H93.2834C93.2532 14.2813 93.2723 13.5593 93.2618 12.838C93.5634 12.8197 93.9063 12.7731 94.1096 12.522C94.2552 12.3541 94.2126 12.1213 94.2178 11.918C94.2237 9.90622 94.2218 7.89441 94.2204 5.88261C94.2329 5.67081 94.1339 5.4013 93.9018 5.35933C93.5818 5.34818 93.4178 5.70228 93.4106 5.97703C93.4041 6.62556 93.4086 7.27474 93.4027 7.92392C92.566 7.92851 91.7293 7.91802 90.8926 7.9154C90.8926 6.27736 90.8926 4.63999 90.8926 3.00195Z"
            fill="#002346"
          />
          <path
            d="M40.5009 33.3777C39.2544 33.3807 38.1039 33.7932 37.1784 34.4862L37.1934 34.4757L32.2449 29.9787C33.4749 28.3332 34.2144 26.2602 34.2144 24.0132C34.2144 21.5922 33.3564 19.3722 31.9269 17.6397L31.9404 17.6562L37.4064 12.1917C38.2824 12.7782 39.3594 13.1277 40.5174 13.1277C43.6329 13.1277 46.1574 10.6032 46.1574 7.48766C46.1574 4.37216 43.6329 1.84766 40.5174 1.84766C37.4019 1.84766 34.8774 4.37216 34.8774 7.48766C34.8774 8.64716 35.2269 9.72416 35.8269 10.6197L35.8134 10.5987L30.3489 16.0632C28.6314 14.6472 26.4084 13.7877 23.9829 13.7877C22.5774 13.7877 21.2409 14.0757 20.0259 14.5977L20.0919 14.5722L18.5439 11.7612C19.7304 10.7292 20.4759 9.21866 20.4759 7.53266C20.4759 4.44266 17.9709 1.93916 14.8824 1.93916C11.7939 1.93916 9.28889 4.44416 9.28889 7.53266C9.28889 10.6227 11.7939 13.1262 14.8824 13.1262C14.8929 13.1262 14.9049 13.1262 14.9154 13.1262C15.5124 13.1172 16.0809 13.0167 16.6134 12.8352L16.5744 12.8472L18.1299 15.6717C15.4944 17.5362 13.7949 20.5692 13.7889 24.0012V24.0027C13.8039 25.0482 13.9764 26.0487 14.2839 26.9877L14.2644 26.9172L12.1299 27.8217C11.1084 26.3652 9.43739 25.4262 7.54589 25.4262C4.46189 25.4262 1.96289 27.9252 1.96289 31.0092C1.96289 34.0932 4.46189 36.5922 7.54589 36.5922C10.6299 36.5922 13.1289 34.0932 13.1289 31.0092C13.1289 30.6132 13.0884 30.2277 13.0104 29.8557L13.0164 29.8917L15.1449 28.9887C16.8954 32.1282 20.1954 34.2162 23.9829 34.2162C26.5779 34.2162 28.9449 33.2352 30.7329 31.6242L30.7239 31.6317L35.6874 36.1422C35.1849 36.9582 34.8849 37.9437 34.8789 39.0012C34.8789 42.1077 37.3974 44.6277 40.5039 44.6277C43.6104 44.6277 46.1289 42.1092 46.1289 39.0027C46.1289 35.8962 43.6104 33.3777 40.5039 33.3777H40.5009ZM11.5359 7.50266C11.5359 5.63816 13.0464 4.12766 14.9109 4.12766C16.7754 4.12766 18.2859 5.63816 18.2859 7.50266C18.2859 9.36716 16.7754 10.8777 14.9109 10.8777C13.0479 10.8747 11.5389 9.36566 11.5359 7.50266ZM7.50089 34.3827C5.63789 34.3812 4.12889 32.8722 4.12889 31.0092C4.12889 29.1462 5.63939 27.6357 7.50239 27.6357C9.36539 27.6357 10.8744 29.1447 10.8759 31.0077C10.8729 32.8707 9.36389 34.3797 7.50089 34.3827ZM40.5009 4.12766C42.3654 4.12766 43.8759 5.63816 43.8759 7.50266C43.8759 9.36716 42.3654 10.8777 40.5009 10.8777C38.6364 10.8777 37.1259 9.36716 37.1259 7.50266C37.1289 5.63966 38.6379 4.13066 40.5009 4.12766ZM16.0359 24.0027C16.0359 24.0027 16.0359 24.0027 16.0359 24.0012C16.0359 19.6032 19.6014 16.0377 23.9994 16.0377C28.3974 16.0377 31.9629 19.6032 31.9629 24.0012C31.9629 28.3992 28.3974 31.9647 23.9994 31.9647C19.6029 31.9602 16.0419 28.3977 16.0359 24.0027ZM40.5009 42.3777C38.6364 42.3777 37.1259 40.8672 37.1259 39.0027C37.1259 37.1382 38.6364 35.6277 40.5009 35.6277C42.3654 35.6277 43.8759 37.1382 43.8759 39.0027C43.8729 40.8657 42.3639 42.3747 40.5009 42.3777Z"
            fill="#002346"
          />
        </svg>
      </div>
      <div className="search-bar">
        <div className="form-inline position-relative">
          <input
            className="input__field"
            type="search"
            placeholder={t("search")}
            aria-label="Search"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="secrico" type="submit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
                stroke="#667085"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="scrollable-menu">
        <div className="nav-bar-left">
          <Accordion defaultActiveKey="0" className="sidebar-menu-wrapper">
            {menuData?.menu
              ?.filter((parentItem) => {
                const parentMatch = parentItem?.title
                  ?.toLowerCase()
                  ?.includes(searchTerm.toLowerCase());
                const childMatch = parentItem?.submenu?.some((subItem) =>
                  subItem?.title
                    ?.toLowerCase()
                    ?.includes(searchTerm?.toLowerCase())
                );
                return parentMatch || childMatch;
              })
              .filter((element) => element?.title != "Feedback")
              .map((item, index) => {
                return (
                  <Accordion.Item
                    key={index}
                    eventKey={index}
                    onClick={
                      item.submenu.length === 0
                        ? () => handleItemClick(item)
                        : null
                    }
                    className={
                      item.submenu.length === 0 ? "hide-dropdown-icon" : ""
                    }
                  >
                    <Accordion.Header>
                      {item.ico && (
                        <img
                          src={item.ico}
                          alt={item.title}
                          width="24"
                          height="24"
                        />
                      )}{" "}
                      {item.title}
                    </Accordion.Header>
                    {item.submenu.length > 0 && (
                      <Accordion.Body>
                        <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                          {item?.submenu
                            ?.filter((subItem) =>
                              subItem?.title
                                ?.toLowerCase()
                                ?.includes(searchTerm?.toLowerCase())
                            )
                            .map((subItem, index) => {
                              return (
                                <li
                                  key={index}
                                  onClick={() => handleItemClick(subItem)}
                                  className={`cursor-pointer ${
                                    selectedSubItem?.title === subItem.title
                                      ? "selected-background"
                                      : ""
                                  }`}
                                >
                                  {subItem.title}
                                </li>
                              );
                            })}
                        </ul>
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                );
              })}
          </Accordion>
        </div>
        <div className="learning-password">
          <ul className="supportlink cursor-pointer">
            {/* <li
              onClick={() =>
                window.open("https://infiniiti-jfs.niit.com/", "_blank")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.13626 9.13628L4.92893 4.92896M4.92893 19.0711L9.16797 14.8321M14.8611 14.8638L19.0684 19.0711M19.0684 4.92896L14.8287 9.16862M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
                  stroke="#667085"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {t("learningSupport")}
            </li> */}
            {/* <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Settings
            </li> */}
          </ul>
        </div>
        {/* <div className="learning-password">
          <ul className="supportlink cursor-pointer">
            <li
              onClick={() =>
                // window.open("https://infiniiti-jfs.niit.com/", "_blank")
                navigate("/categories")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="#667085"
              >
                <path d="M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7H8V9H6V7ZM6 11H8V13H6V11ZM6 15H18V17H6V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7ZM16 7H18V9H16V7ZM16 11H18V13H16V11Z"></path>
              </svg>
              
              {t("category")}
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Settings
            </li>
          </ul>
        </div> */}
        <div>
          {/* {isModalOpen && (
            <div className="menu-message">
              <div className="message-title">How to add your data?</div>
              <span className="clost-message cursor-pointer" onClick={closeDataModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15 5L5 15M5 5L15 15"
                    stroke="#667085"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <div className="discription">
                Learn how to bring in your data for context and customise the
                assistant.
              </div>
              <div className="message-btns cursor-pointer">
                <span className="dismissbtns" onClick={closeDataModal}>Dismiss</span>
                <span className="dismissbtns active">Check it out</span>
              </div>
            </div>
          )} */}
        </div>
        <div className="user-info">
          <div className="user-proile">
            <div className="user-avtar">
              <img
                src="/images/Avatar.png"
                width={40}
                height={40}
                className="avtar-user"
                alt="profile"
              />
            </div>
            <div className="inof-suer">
              <div className="username">
                {user?.firstName} {user?.lastName}
              </div>
              <div className="useremail" title={user?.emailID}>
                {user?.emailID}
              </div>
            </div>
          </div>
          <div className="logut-btn cursor-pointer" onClick={handleSignOut}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5"
                stroke="#667085"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashBoardSideBar;
